import { render, staticRenderFns } from "./SetDefaultWarehouse.vue?vue&type=template&id=5e6a2db6&scoped=true"
import script from "./SetDefaultWarehouse.vue?vue&type=script&lang=js"
export * from "./SetDefaultWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6a2db6",
  null
  
)

export default component.exports